<app-card-secondary [formGroup]="form" titleKey="COST-COVERAGE_TRAVEL-EXPENSES">
  <div class="row">
    <div class="col-md-12 mandatory">
      <span i18n>Die Reisekosten und die Lebenshaltungskosten während des Aufenthalts des Antragstellers/der Antragstellerin werden getragen:</span>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-3 mt-3">
      <div>
        <input id="reisedaten.reisekostenUebernahme.isAntragsteller"
               class="form-check-input" type="checkbox"
               formControlName="isAntragsteller"
               [ngbPopover]="popover_reisedaten_reisekostenUebernahme_isAntragsteller"
               appSaveLastFocussed
        >
        <label for="reisedaten.reisekostenUebernahme.isAntragsteller" i18n>durch Antragstellende(n) selbst</label>
        <ng-template #popover_reisedaten_reisekostenUebernahme_isAntragsteller>
          <app-assistant (assistantDisabled)="disableAssistant()">
            <span i18n>Bitte markieren Sie dieses Feld, wenn der/die Antragstellende die Reise- und Lebenshaltungskosten trägt. Die Kosten können sowohl durch den/die Antragstellende(n) allein als auch gemeinsam mit einem Dritten getragen werden.</span>
          </app-assistant>
        </ng-template>
      </div>
    </div>

    <div class="col-md-6 mb-3 mt-3">
      <div>
        <input id="reisedaten.reisekostenUebernahme.isDritte"
               class="form-check-input" type="checkbox"
               formControlName="isDritte"
               [ngbPopover]="popover_reisedaten_reisekostenUebernahme_isDritte"
               appSaveLastFocussed
        >
        <label for="reisedaten.reisekostenUebernahme.isDritte" i18n>durch Dritte (Gastgeber, Unternehmen, Organisation), bitte nähere
          Angaben</label>
        <ng-template #popover_reisedaten_reisekostenUebernahme_isDritte>
          <app-assistant (assistantDisabled)="disableAssistant()">
            <span i18n>Bitte markieren Sie dieses Feld, wenn die Reise- und Lebenshaltungskosten teilweise oder komplett von einem Dritten getragen werden.</span>
          </app-assistant>
        </ng-template>
      </div>

      <div class="form-check-indented" *ngIf="form.value.isDritte === true">
        <input id="reisedaten.reisekostenUebernahme.einlader"
               class="form-check-input" type="checkbox"
               [formControl]="$any(form.get('einlader'))"
               [ngbPopover]="popover_reisedaten_reisekostenUebernahme_einlader"
               appSaveLastFocussed
        >
        <label for="reisedaten.reisekostenUebernahme.einlader" i18n>durch den/die Einladende(n), siehe oben gemachte Angaben</label>
        <ng-template #popover_reisedaten_reisekostenUebernahme_einlader>
          <app-assistant (assistantDisabled)="disableAssistant()">
            <span i18n>Bitte markieren Sie dieses Feld, wenn die oben genannte Referenz die Reise- und Lebenshaltungskosten trägt.</span>
          </app-assistant>
        </ng-template>
      </div>

      <div class="form-check-indented" *ngIf="form.value.isDritte === true">
        <input id="reisedaten.reisekostenUebernahme.organisation"
               class="form-check-input" type="checkbox"
               [formControl]="$any(form.get('organisation'))"
               (change)="toggleAndereValueChanged($event)"
               [ngbPopover]="popover_reisedaten_reisekostenUebernahme_organisation"
               appSaveLastFocussed
        >
        <label for="reisedaten.reisekostenUebernahme.organisation" i18n>durch andere (siehe Angaben zum/zur abweichenden
          Verpflichtungsgebenden)</label>
        <ng-template #popover_reisedaten_reisekostenUebernahme_organisation>
          <app-assistant (assistantDisabled)="disableAssistant()">
            <span i18n>Bitte markieren Sie dieses Feld, wenn die Reise- und Lebenshaltungskosten (zusätzlich) durch jemand anderen als den/die Antragstellende und/oder die Referenz getragen werden.</span>
          </app-assistant>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-3 mt-2">
      <div *ngIf="form.get('isAntragsteller').value"
           style="display: flex; flex-direction: column; justify-content: space-between; height: 100%">
        <div>
          <span i18n>Durch Antragstellende(n) bereitgestellte Mittel zur Bestreitung des Lebensunterhalts:</span>
          <div class="mt-2 mb-1">
            <app-checkbox-group
              [checkboxes]="$any(checkboxesForAntragstellerLebensunterhalt)"
              [textPrefix]="'reisekosten.antragstellerLebensunterhalt.'"/>
          </div>
        </div>
        <div>
          <app-input
            *ngIf="form.get('sonstiges').value"
            [fieldId]="'sonstigesText'"
            [type]="'text'"
            [control]="form.get('sonstigesText')"
            [assistantServiceEnabled]="appConfig.isAssistantAvailable"
            [saveLastFocusedEnabled]="true"
            [toUpperCaseEnabled]="true"
            [popOverName]="'sonstigesText'">
            <span i18n>Bitte machen Sie hier weitere Angaben zur Bestreitung des Lebensunterhalts während des Aufenthalts.</span>
          </app-input>
        </div>
      </div>
    </div>

    <div class="col-md-6 mb-3 mt-2">
      <div *ngIf="form.get('isDritte').value && (form.get('einlader').value || form.get('organisation').value)"
           style="display: flex; flex-direction: column; justify-content: space-between; height: 100%">
        <div>
          <span i18n>Durch Dritte bereitgestellte Mittel zur Bestreitung des Lebensunterhalts:</span>
          <div class="mt-2 mb-1">
            <app-checkbox-group
              [checkboxes]="$any(checkboxesForDritteLebensunterhalt)"
              [textPrefix]="'reisekosten.dritte.dritteLebensunterhalt.'"/>
          </div>
        </div>
        <div>
          <app-input
            *ngIf="form.get('dritteSonstiges').value"
            [fieldId]="'dritteSonstigesText'"
            [type]="'text'"
            [control]="form.get('dritteSonstigesText')"
            [assistantServiceEnabled]="appConfig.isAssistantAvailable"
            [saveLastFocusedEnabled]="true"
            [toUpperCaseEnabled]="true"
            [popOverName]="'sonstigesText'">
            <span i18n>Bitte machen Sie hier weitere Angaben zur Bestreitung des Lebensunterhalts während des Aufenthalts.</span>
          </app-input>
        </div>
      </div>
    </div>
  </div>
</app-card-secondary>
